class FeaturedLimitedCarousel {
  constructor(container) {
    this.container = container;

    this.items = this.container.querySelectorAll(
      '.featured-limited__mobile-product-item'
    );

    this.counterCurrent = this.container.querySelector(
      '.featured-limited__mobile-counter-current'
    );

    this.current = 0;
    this.timer = null;
    this.resumeTimer = null;
    this.counterTimer = null;

    this.init();
  }

  init() {
    if (window.innerWidth > 749) return;
    if (this.items.length < 2) return;

    this.show(this.current);
    this.startAutoPlay();
  }

  show(index) {
    const nextIndex = (index + 1) % this.items.length;

    this.items.forEach((item, i) => {
      item.classList.remove('active', 'next');

      if (i === index) {
        item.classList.add('active');
      } else if (i === nextIndex) {
        item.classList.add('next');
      }
    });

    this.current = index;
    this.updateCounter(index + 1);
  }

  updateCounter(number) {
    if (!this.counterCurrent) return;

    clearTimeout(this.counterTimer);

    this.counterCurrent.classList.add('is-fading');

    this.counterTimer = setTimeout(() => {
      this.counterCurrent.textContent = String(number);

      requestAnimationFrame(() => {
        this.counterCurrent.classList.remove('is-fading');
      });
    }, 120);
  }

  startAutoPlay() {
    clearInterval(this.timer);

    this.timer = setInterval(() => {
      this.show((this.current + 1) % this.items.length);
    }, 4000);
  }

  pauseAutoPlay() {
    clearInterval(this.timer);
  }

  resumeAutoPlay() {
    clearTimeout(this.resumeTimer);

    this.resumeTimer = setTimeout(() => {
      this.startAutoPlay();
    }, 10000);
  }
}

document
  .querySelectorAll('[data-limited-carousel]')
  .forEach(container => {
    new FeaturedLimitedCarousel(container);
  });

function syncFeaturedLimitedHeight() {
  if (window.innerWidth <= 749) return;

  document.querySelectorAll('.featured-limited').forEach(section => {
    const video = section.querySelector('.featured-limited__video-wrapper');
    const products = section.querySelector('.featured-limited__products');

    if (!video || !products) return;

    products.style.height = `${video.offsetHeight}px`;
  });
}

window.addEventListener('load', syncFeaturedLimitedHeight);
window.addEventListener('resize', syncFeaturedLimitedHeight);

document.querySelectorAll('.featured-limited video').forEach(video => {
  video.addEventListener('loadedmetadata', syncFeaturedLimitedHeight);
});